// LED Routes
export const ROUTE_LED_JIT = '/subaru-reports/led-just-in-time';
export const ROUTE_LED_RETAILER_PERFORMANCE = '/subaru-reports/led-retailer-performance';
export const ROUTE_LED_DELIVERY_SPECIALIST = '/subaru-reports/led-delivery-specialist';

// Love Promise Routes
export const ROUTE_LP_HOME_PAGE = '/love-promise/home-page';
export const ROUTE_LP_RETAILER_REPORT = '/love-promise/retailer-report';
export const ROUTE_LP_SUPPORT_DOCUMENTS = '/love-promise/support-documents';
export const ROUTE_LP_CORPORATE_REPORT = '/love-promise/corporate-report';

// OLP Report Routes
export const ROUTE_REPORTS_LANDING = '/subaru-reports/landing';
export const ROUTE_REPORTS_JIT = '/subaru-reports/just-in-time';
export const ROUTE_REPORTS_COMMENTS = '/subaru-reports/comments-report';
export const ROUTE_REPORTS_SNAPSHOT = '/subaru-reports/scores-snapshot';
export const ROUTE_REPORTS_TREND = '/subaru-reports/scores-trend';
